import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { DsIcon } from '../DsIcon';
export class DsRemixIcon extends PureComponent {
    render() {
        return _jsx(DsIcon, { baseClassName: "", ...this.props });
    }
}
